module.exports = __webpack_public_path__ + "static/media/recent-order-inactive.27ecac46.svg";